/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/no-unknown-property */
import React, { Component } from "react";
import Header from "../Components/Header";
import SubHeader from "../Components/SubHeader";
import Loader from "../Components/Loader";
import Footer from "../Components/Footer";
import Cookies from "js-cookie";

import "../Styles/ofislerimiz.css";

export default class ClarificationText extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ loading: false });
    }, 500);
  }

  render() {
    return (
      <>
        <Loader />
        <SubHeader />
        <Header isLoggedIn={Cookies.get("token") != null} />

        <div className="offices-header">
          <div className="offices-header-pattern" />
          <div className="container offices-header-container">
            <div className="row">
              <div className="text-center">
                <h1 className="offices-header-title">
                  İletişim Formu Aydınlatma Metni
                </h1>
              </div>
            </div>
          </div>
        </div>

        <div className="ex-basic-2">
          <div className="container">
            <div className="row mt-5 mb-5">
              <div className="col-lg-12">
                <div className="metin-kutusu">
                  <h1>İLETİŞİM FORMU DOLDURANLAR İÇİN</h1>
                  <h3>Kişisel Verilerin Korunması ve İşlenmesi Aydınlatma Metni</h3>

                  <p>
                    Adil Onur Karahan Şahıs Şirketi kişisel verilerinizin hukuka uygun olarak toplanması, saklanması ve paylaşılmasını sağlamak ve gizliliğinizi korumak amacıyla mümkün olan en üst seviyede güvenlik tedbirlerini almaktadır.
                  </p>

                  <p>
                    Bu Aydınlatma Metnini hazırlamadaki amacımız; 6698 sayılı Kişisel Verilerin Korunması Kanununun 10. maddesi gereğince, kişisel verilerinizin alınma şekilleri, işlenme amaçları, paylaşılan kişiler, hukuki nedenleri ve haklarınız konularında sizi en şeffaf şekilde bilgilendirmektir.
                  </p>

                  <p>
                    İşbu Aydınlatma Metni, 6698 sayılı Kişisel Verilerin Korunması Kanunu ("Kanun") uyarınca, Adil Onur Karahan Şahıs Şirketi (“Şirket”) tarafından, iletişim formu dolduran veri sahiplerinden temin edilen kişisel verilerin işlenmesinin usul ve esaslarına ilişkin veri sahiplerinin aydınlatılması amacı ile düzenlenmiştir.
                  </p>

                  <h4>1. Veri Sorumlusunun Kimliği</h4>
                  <ul>
                    <li><strong>Unvan:</strong> Adil Onur Karahan Şahıs Şirketi</li>
                    <li><strong>E-posta Adresi:</strong> yazilimkodjet@gmail.com</li>
                    <li><strong>İnternet Adresi:</strong> nmuniversalteam.com</li>
                    <li><strong>Posta Adresi:</strong> KIZILIRMAK MAH. UFUK ÜNİVERSİTESİ CAD. NO: 12 İÇ KAPI NO: 3 ÇANKAYA/ ANKARA</li>
                  </ul>

                  <h4>2. Kişisel Veriler ve Verilerin İşlenme Amacı ve Hukuki Sebep</h4>
                  <p>
                    Kanun uyarınca, veri sorumlusu Şirket olarak şahsınıza ait olan kişisel verilerinizden;
                  </p>
                  <ul>
                    <li>Ad,</li>
                    <li>Soyad,</li>
                    <li>E-posta Adresi,</li>
                    <li>Cep Telefonu</li>
                  </ul>
                  <p>
                    bilgilerinizi işlemeyi talep ediyoruz.
                    Ad, Soyadı, e-posta ve cep telefonu veriniz; sizinle iletişime geçilmesi, talep ve şikâyet mesajlarınızın değerlendirilmesi amaçları ile Kanun’un 5. ve 6. maddelerinde belirtilen kişisel veri işleme şartlarına uygun ve yukarıda verilen amaçlarla sınırlı olarak işlenecektir.
                  </p>

                  <h4>3. Kişisel Verilerin Kimlere ve Hangi Amaçla Aktarılabileceği</h4>
                  <p>
                    Kanun’un 8. maddesine uygun olarak kişisel verileriniz; İşbu Aydınlatma Metni’nin 2. maddesinde yer alan amaçlarla;
                    Yurt içindeki kanunen yetkili kamu resmi kurum ve kuruluşları, hizmet sağlayıcı firmalar ve yetkilileri, çağrı merkezi hizmet sunucuları, tedarikçiler ve destek hizmeti sağlayıcılar ve iş ortakları ile paylaşılabilecektir.
                  </p>

                  <h4>4. Kişisel Verilerin Toplanma Yöntemi</h4>
                  <p>
                    Kişisel verileriniz internet adresimizde yer alan sayfadan, tarafınızca yapılan başvuru vasıtasıyla toplanmaktadır.
                  </p>

                  <h4>5. Kanun’un 11. maddesinde sayılan haklarınız</h4>
                  <p>İlgili Kişi olarak, Kanun’un 11. maddesi uyarınca aşağıdaki haklara sahipsiniz:</p>
                  <ol>
                    <li>Kişisel verisinin işlenip işlenmediğini öğrenme,</li>
                    <li>Kişisel verileri işlenmişse buna ilişkin bilgi talep etme,</li>
                    <li>Kişisel verilerin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme,</li>
                    <li>Yurt içinde veya yurt dışında kişisel verilerin aktarıldığı üçüncü kişileri bilme,</li>
                    <li>Kişisel verilerin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme ve bu kapsamda yapılan işlemin kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme,</li>
                    <li>KVKK ve ilgili diğer kanun hükümlerine uygun olarak işlenmiş olmasına rağmen, işlenmesini gerektiren sebeplerin ortadan kalkması hâlinde kişisel verilerin silinmesini veya yok edilmesini isteme ve bu kapsamda yapılan işlemin kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme,</li>
                    <li>İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle kişinin kendisi aleyhine bir sonucun ortaya çıkmasına itiraz etme,</li>
                    <li>Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğraması hâlinde zararın giderilmesini talep etme.</li>
                  </ol>

                  <p>İlgili kişi olarak yukarıda sayılan haklarınıza ilişkin taleplerinizi aşağıdaki adresler üzerinden Şirketimize iletebilirsiniz:</p>
                  <ul>
                    <li><strong>E-posta Adresi:</strong> yazilimkodjet@gmail.com</li>
                    <li><strong>İnternet Adresi:</strong> nmuniversalteam.com</li>
                    <li><strong>Posta Adresi:</strong> KIZILIRMAK MAH. UFUK ÜNİVERSİTESİ CAD. NO: 12 İÇ KAPI NO: 3 ÇANKAYA/ ANKARA</li>
                  </ul>

                  <p>
                    İlgili kişi olarak bulunmuş olduğunuz talepleriniz Şirket tarafından, en kısa sürede ve nihayetinde en geç otuz (30) gün içerisinde ücretsiz olarak değerlendirilip sonuçlandırılacaktır. İşlemin ayrıca bir maliyeti gerektirmesi durumunda Kişisel Verileri Koruma Kurulu tarafından belirlenen tarifedeki ücret esas alınacaktır.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}
